import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { IItemCatalog, IItemList } from '../../../../../core/models';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { UserService } from '../../../../../core/services/user.service';
import { AdminService } from '../../../../../core/services/admin.service';
import { formatDate } from '@angular/common';
import { CommonService } from '../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { ItemSuggestion } from 'src/app/core/models';
import { ItemService } from 'src/app/core/services/item.service';
import { Subject } from 'rxjs';
import { NotifyType } from '../../../../../core/enums/NotifyType';


@Component({
  selector: 'app-item-administration',
  templateUrl: './item-administration.component.html',
  styleUrls: ['./item-administration.component.scss']
})
export class ItemAdministrationComponent implements OnInit {
  itemLoading: boolean = false;
  loadingPDF: boolean = false;
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
 
  //#region  constructor & ngOnInit
  constructor(private userService: UserService,
    private appNotifyService: AppNotifyService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private commonService: CommonService, private itemService: ItemService) {
    //this.bindGridResult();
  }

  ngOnInit(): void {
    this.loadItemGrid();
  }

  //#endregion
  //#region Member Variables & getters & Setters
  itemGridDataResult: GridDataResult;
  items: IItemCatalog[] = [];

  //#endregion

  //#region Grid Variable & Events
  public gridSettings = {
    loading: this.itemLoading,
    showGrid: true,
    label: {
      shortDescription: "Short Description",
      longItemNumber: "Long Item Number",
      description1: "Description1",
      size: "Size",
      finishValue: "Finish Value",
      actions: "Actions",
      itemNumber: "Item Number",
      fullDescription: "Full Description",
      basePrice: "Base Price",
      v6Price: "V6 Price",
      priceBookCategoryDescription: "Category",
      isActive: "IsActive"
    }
  };

  public gridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'id',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  loadItemGrid(): void {
    this.itemLoading = true;
    this.adminService.getItemCatalog().subscribe((response) => {
      this.items = response;
      this.bindItemGridResult();
      this.itemLoading = false;

    });
  }
  public bindItemGridResult(): void {
    const data = this.items;
    this.itemGridDataResult = process(data, this.gridstate);
  }

  public itemGridSortChange(sort: SortDescriptor[]): void {
    this.gridstate.sort = sort;
    this.bindItemGridResult();
  }
  public itemGridPageChange({ skip, take }: PageChangeEvent): void {
    this.gridstate.skip = skip;
    this.gridstate.take = take;
    this.bindItemGridResult();
  }

  public itemGridDataStateChange(state: DataStateChangeEvent): void {
    this.gridstate = state;
    this.bindItemGridResult();
  }
  //#endregion
  //#region  Page Events



  //#endregion
  onEditItem(item: IItemCatalog) {
    this.router.navigate(['/itemAdministration/addItem'], {
      queryParams: { id: item.id }
    });
  }

  //#region Export to PDF and Excel
  async generatePDF() {
    this.loadingPDF = true;

    var todaysDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: 'KawneerDirect Items', alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          layout: 'lightHorizontalLines',
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        //{
        //  text: "Customer Id :" + this.adminService.us customerNumber,
        //  bold: true,
        //  margin: [0, 15, 0, 15]
        //},
        //{
        //  text: "Customer Name : " + this.quoteService.readUserObject.customerName,
        //  bold: true,
        //  margin: [0, 15, 0, 15]
        //},
        {
          text: "KawneerDirect Item List",
          style: 'sectionHeader'
        },
        {
          table: {
            headerRows: 1,
            widths: [50, 50, 60, 60, 40, 50, 30, 40, 40],
            //widths: ['*'],
            body: [
              [this.gridSettings.label.itemNumber, this.gridSettings.label.longItemNumber,
              this.gridSettings.label.shortDescription, this.gridSettings.label.fullDescription,
              this.gridSettings.label.finishValue, this.gridSettings.label.description1,
              this.gridSettings.label.size, this.gridSettings.label.basePrice,
              this.gridSettings.label.v6Price],
              ...this.items.map(p =>
                ([
                  p.itemNumber,
                  p.longItemNumber ? p.longItemNumber : '',
                  p.shortDescription ? p.shortDescription : '',
                  p.fullDescription ? p.fullDescription : "",
                  p.finishValue ? p.finishValue : '',
                  p.description1 ? p.description1 : '',
                  p.size ? p.size : '',
                  p.basePrice ? p.basePrice : '',
                  p.v6Price ? p.v6Price : '',
                ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        }
      }
    };
    pdfMake.createPdf(docDefinition).download('KawneerDirectItemCatalog.pdf');
    this.loadingPDF = false;

  }
  //#region Associate item dialog operations
  itemId: string;
  //#region item suggestion auto complete textbox
  public filteredSuggestions: ItemSuggestion[] = [];
  selectedItemDescription: any;
  selectedItemNumber: string;
  selectedItemSuggestion: ItemSuggestion = new ItemSuggestion();
  itemsLoading: boolean;
  selectedItem: IItemList;
  handleItemFilter(searchQuery: string) {
    if (searchQuery.length > 0) {
      searchQuery = searchQuery.toUpperCase();
      this.itemsLoading = true;
      this.itemService.getItemSuggestions({
        searchstring: searchQuery,
        categoryId: -1,
        customerNumber: this.userService.readUserObject.customerNumber,
        countryCode: this.userService.readUserObject.countryCode,
      })
        .subscribe((resp: ItemSuggestion[]) => {
          this.filteredSuggestions = resp;
          this.itemsLoading = false;
        });
    }
  }

  itemSelected(itemFullDescription) {
    this.selectedItemSuggestion = this.filteredSuggestions.find((r) =>
      r.fullDescription.toUpperCase().startsWith(itemFullDescription.toUpperCase())
    );
    if (!this.selectedItemSuggestion) {
      return;
    }
    this.loadItemDetails(this.selectedItemSuggestion.itemNumber);
  }
  loadItemDetails(itemNumber: string) {
    this.itemsLoading = true;
    const customerNumber = this.userService.readUserObject.customerNumber;
    this.itemService.getItemDetails(itemNumber, customerNumber)
      .subscribe((data) => {
        this.selectedItem = data;
        this.itemsLoading = false;
      });
  }

  //#endregion
  associateItem = {
    opened: false,
    isEmptyItem: false,
    isSubmitted: false,
    isAssociateSuccess: false,
    isAssociateError: false,
    successMessageLbl: "",
    errorMessageLbl: "",
  }
  toggleAssociateDialog(data) {
    this.associateItem.opened = !this.associateItem.opened;
    if (this.associateItem.opened == true) {
      if (data) {
        this.itemId = data.itemNumber; //stores the item id which will be used in modal dialog operations
        this.loadAssociateItemGrid(this.itemId);
      }
    } else {
      this.resetAssociateDialog();
    }
  }
  //to load the associate grid data 
  loadAssociateItemGrid(id) {
    const body = {
      itemNumber: id
    }
    this.itemService.getAssociateItems(body).subscribe(response => {
      console.log(response);
      this.AssociateGridData = response;
      this.bindAssociateItemGrid();
    })
  }
  resetAssociateDialog() {
    this.selectedItemNumber = "";
    this.associateItem.isEmptyItem = false;
    this.associateItem.isSubmitted = false;
    this.associateItem.isAssociateSuccess = false;
    this.associateItem.isAssociateError = false;
    this.associateItem.successMessageLbl = "";
    this.associateItem.errorMessageLbl = "";
  }
  validateItemText() {
    let isValid = true;
    if (this.associateItem.isSubmitted == true) {
      if (this.selectedItemNumber) {
        this.associateItem.isEmptyItem = false;
      } else {
        this.associateItem.isEmptyItem = true;
        isValid = false;
      }
    }
    return isValid;
  }
  //for saving the item on associate button click
  saveAssociateItem() {
    this.associateItem.isSubmitted = true;
    if (!this.validateItemText()) {
      return;
    }
    this.associateItem.successMessageLbl = "";
    this.associateItem.errorMessageLbl = "";
    const body = {
      itemNumber: this.itemId,
      associatedItemNumber: this.selectedItem.itemNumber,
      isActive: true
    }
    this.itemService.saveAssociateItems(body).subscribe(response => {
      if (response) {
        this.loadAssociateItemGrid(this.itemId);
        this.associateItem.isAssociateSuccess = true;
        this.associateItem.isAssociateError = false;
        this.associateItem.successMessageLbl = "Item associated successfully!";
        this.selectedItemNumber = "";
      } else {
        this.associateItem.isAssociateError = true;
        this.associateItem.isAssociateSuccess = false;
        this.associateItem.errorMessageLbl = "Failed!";
      }
    })


  }

  disassociateItem(item) {
    this.associateItem.successMessageLbl = "";
    this.associateItem.errorMessageLbl = "";
    const body = {
      itemNumber: item.itemNumber,
      associatedItemNumber: item.associatedItemNumber,
      isActive: false,
      itemId: item.itemId,
    }
    this.itemService.disasociateItems(body).subscribe(response => {
      if (response) {
        this.loadAssociateItemGrid(this.itemId);
        this.associateItem.isAssociateSuccess = true;
        this.associateItem.isAssociateError = false;
        this.associateItem.successMessageLbl = "Item disassociated successfully!";
      } else {
        this.associateItem.isAssociateError = true;
        this.associateItem.isAssociateSuccess = false;
        this.associateItem.errorMessageLbl = "Failed!";
      }
    })
  }
  //#region pagination, sorting, filtering for Associate grid
  associateItemGridView: GridDataResult;
  AssociateGridData: any;
  public associateItemGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'itemId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindAssociateItemGrid(): void {
    const data = this.AssociateGridData;
    this.associateItemGridView = process(data, this.associateItemGridstate);
  }

  public associateItemGridSortChange(sort: SortDescriptor[]): void {
    this.associateItemGridstate.sort = sort;
    this.bindAssociateItemGrid();
  }
  public associateItemGridPageChange({ skip, take }: PageChangeEvent): void {
    this.associateItemGridstate.skip = skip;
    this.associateItemGridstate.take = take;
    this.bindAssociateItemGrid();
  }

  public associateItemGridDataStateChange(state: DataStateChangeEvent): void {
    this.associateItemGridstate = state;
    this.bindAssociateItemGrid();
  }

  //#endregion
  //#endregion
  //#region delete item
  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.itemRemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public itemRemoveHandler() {
    const itemId = this.gridItemToRemove.id;
    let body = {
      id: itemId
    }
    this.itemService.deleteItem(body).subscribe(() => {
     
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected item has been removed.");

      if (this.items) {
          //This is a Local Remove
        const index = (this.items).findIndex(r => r.id === itemId);
        (this.items).splice(index, 1);
          this.bindItemGridResult();

        }

    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
